<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" left-arrow :safe-area-inset-top="true" title="我的档案" />
    </van-sticky>
		<div class="search-list">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        finished-text="没有更多了"
        @load="onLoad">
        <div v-for="(student,index) in tabData" :key="index" class="item">
          <!-- 信息 -->
          <van-cell-group inset>
            <div class="baseinfo flex-row-start">
              <img class="headimg" src="../../../assets/images/headimg.jpg" />
              <div>
                <div class="flex-row-start">
                  <div class="font-bigger name">{{ student.name }}</div>
                  <div v-if="student.sex">
                    <img v-if="student.sex.key == 'Male'" src="../../../assets/images/male.png" class="sex" />
                    <img v-if="student.sex.key == 'Female'" src="../../../assets/images/female.png" class="sex" />
                  </div>
                </div>
                <div v-if="student.height || student.weight" class="detailinfo flex-row-start">
                  <div v-if="student.height" class="font-intro pr40">身高：{{ student.height }}cm</div>
                  <div v-if="student.weight" class="font-intro pr40">体重：{{ student.weight }}kg</div>
                </div>
              </div>
            </div>
            <div class="content">
              <div class="flex-col-center">
                <div>
                  {{ student.classVO.grade.name }}
                </div>
                <div class="font-intro">年级</div>
              </div>
              <div class="flex-col-center">
                <div>{{ student.classVO.name }}</div>
                <div class="font-intro">班级</div>
              </div>
              <div class="flex-col-center">
                <div>{{ student.teacher.name }}</div>
                <div class="font-intro">老师</div>
              </div>
            </div>
          </van-cell-group>
        </div>
      </van-list>
		</div>
  </div>
</template>
<script>
import { fetchPageView } from "../../../api/student"
export default {
  data() {
    return {
      searchValue: '',
      offset: 0,//滚动条与底部距离小于 offset 时触发load事件，默认300
      pageNum: -1, // 当前页码
      pageSize: 10, // 分页大小
      total: 0, // 查询总条数
      loading: false, // 滚动加载中
      finished: false, // 滚动加载完成
      tabData: []
    };
  },
  components: {
  },
  created() {
    this.init()
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    onClickLeft() {
      history.back()
    },
    init() {
      this.$nextTick(() => {
        this.handleButtonSearchInfors()
      })
    },
    //点击键盘上的搜索/回车按钮后触发
    handleEnterSearchInfors(val) {
      console.log(val);
    },
    handleButtonSearchInfors() {
      this.pageNum = 0
      this.tabData = []
      this.loadData()
    },
    // 滚动加载更多
    onLoad() {
      this.pageNum++
      this.loading = true
      this.loadData()
    },
    loadData() {
      if (this.loading) return false
      fetchPageView({
        keyWord: this.searchValue,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }, {}).then(res => {
        var data = res.content
        this.loading = false
        this.tabData = this.tabData.concat(data)
        if (data.length < this.pageSize) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../../assets/css/style.css');
.search-container {
  padding: 0.66667rem;
  background-repeat: no-repeat;
  background-size: 100%;
}
.van-search {
  border-radius: 20px;
  /deep/ .van-search__content {
    background-color: #31607b;
  }
  /deep/ input::-webkit-input-placeholder {
    color: #999;
  }
  /deep/ input::-moz-input-placeholder {
    color: #999;
  }
  /deep/ input::-ms-input-placeholder {
    color: #999;
  }
  /deep/ .van-field__control {
    color: #c28831;
  }
}
.van-search__action {
  background-image: radial-gradient(#d8ba79, #c28831);
  padding: 0 32px;
  margin: 0 20px 0 0;
  color: #1b2026;
  border-radius: 20px;
  div {
    font-size: 30px;
  }
}
.search-list {
  padding: 0 40px 40px 40px;
  .item {
    margin-top: 40px;
    border-radius: 16px;
    background: #fff;
  }
}
.custom-title {
  color: #999999;
}
.baseinfo {
  margin-top: 24px;
  .sex {
    width: 24px;
    height: 24px;
    margin-top: 8px;
    margin-left: 8px;
  }
}
.detailinfo {
  padding: 8px 24px 0 24px;
}
.name {
  padding: 24px 24px 0 24px;
}
.headimg {
  border-radius: 50%;
  height: 120px;
  width: 120px;
}
.content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: #999!important;
  background: #f3f3f3;
  margin-top: 16px;
  margin-bottom: 24px;
  padding: 0 40px 24px 40px;
  border-radius: 16px;
  div {
    font-size: .32rem;
    color: #333;
    margin-top: 8px;
  }
  .font-intro {
    font-size: .24rem;
    color: #999;
  }
}
.state {
  font-weight: bold;
  color: #ff9e19;
}
.bottom {
  font-size: .32rem;
  padding: 16px 24px;
}
.font-bigger {
  padding-right: 0px;
}
</style>